:host {
  --aha-card--background-color: var(--theme-accent-background);
  --aha-card--border: 1px solid var(--theme-primary-border);
  --aha-card--border-left-color: transparent;
  --aha-card--border-left-width: 5px;
  --aha-card--border-left-right-border: none;
  --aha-card--font-size: 0.75rem;
  --aha-card--font-color: var(--theme-secondary-text);
  --aha-card--padding: var(--spacer-2);
  --aha-card--left-padding: var(--spacer-2);
  --aha-card--width: auto;
  --aha-card--height: auto;
  --aha-card--header-background: var(--theme-container-background);
  --aha-card--header-background-hover: var(--theme-hover-background);
  --aha-card--header-color: var(--theme-secondary-text);
  --aha-card-row--padding: 0.15rem 0;

  cursor: pointer;
}

.aha-card__body {
  width: var(--aha-card--width);
  height: var(--aha-card--height);
  display: flex;
  flex-direction: column;
  padding: var(--aha-card--padding);
  border: var(--aha-card--border);
  border-radius: var(--Common--border-radius);
  background-color: var(--aha-card--background-color);
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
  transition: all 0.1s ease-in;
  font-size: var(--aha-card--font-size);
  color: var(--aha-card--font-color);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  position: relative;
}

.aha-card__body.with-highlight-color {
  padding-left: calc(var(--aha-card--left-padding) + var(--aha-card--border-left-width));
}

.aha-card__body.with-highlight-color::before {
  content: '';
  position: absolute;
  width: var(--aha-card--border-left-width);
  height: 100%;
  left: 0;
  top: 0;
  background-color: var(--aha-card--border-left-color);
  border-right: var(--aha-card--border-left-right-border);
}

:host([shadow]) .aha-card__body {
  box-shadow: var(--theme-shadow-deep);
}

:host([selected]) .aha-card__body {
  box-shadow: var(--box-shadow-focus-ring);
}

.aha-card__body:hover {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.23);
}

.aha-card__body:focus {
  border: 2px solid var(--theme-blue-border);
}

slot[name='header']::slotted(*) {
  display: block;
  padding: var(--spacer-1) var(--spacer-2);
  background-color: var(--aha-card--header-background) !important;
  color: var(--aha-card--header-color) !important;
  border-radius: var(--Common--border-radius) var(--Common--border-radius) 0 0;
  border: 1px solid var(--theme-secondary-border);
  border-bottom: none;
  margin: 0 var(--spacer-1);
}

slot[name='header']::slotted(a:hover) {
  background-color: var(--aha-card--header-background-hover) !important;
  text-decoration: none !important;
}

slot[name='header'][hidden] {
  display: none;
}

.aha-card__image {
  margin: calc(-1 * var(--aha-card--padding));
  margin-bottom: var(--aha-card--padding);
}

.aha-card__image slot {
  height: 60px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

slot[name='image']::slotted(img) {
  flex: 1;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
